import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "alert-wrapper"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  class: "error-message-html"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "error-message-html"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_alert = _resolveComponent("b-alert");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [$data.type === $data.types.INFO ? (_openBlock(), _createBlock(_component_b_alert, {
    key: 0,
    modelValue: $data.infoCountDown,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.infoCountDown = $event),
    dismissible: "",
    variant: "primary",
    onClosed: _cache[1] || (_cache[1] = $event => $data.infoCountDown = 0),
    onCloseCountdown: $options.infoCountDownChanged
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString($data.message), 1)]),
    _: 1
  }, 8, ["modelValue", "onCloseCountdown"])) : _createCommentVNode("", true), $data.type === $data.types.SUCCESS && !_ctx.isHtmlMessage ? (_openBlock(), _createBlock(_component_b_alert, {
    key: 1,
    modelValue: $data.successCountDown,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.successCountDown = $event),
    dismissible: "",
    variant: "success",
    onClosed: _cache[3] || (_cache[3] = $event => $data.successCountDown = 0),
    onCloseCountdown: $options.successCountDownChanged
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      innerHTML: $data.message
    }, null, 8, _hoisted_2)]),
    _: 1
  }, 8, ["modelValue", "onCloseCountdown"])) : _createCommentVNode("", true), $data.type === $data.types.SUCCESS && _ctx.isHtmlMessage ? (_openBlock(), _createBlock(_component_b_alert, {
    key: 2,
    modelValue: $data.successCountDown,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.successCountDown = $event),
    dismissible: "",
    variant: "success",
    onClosed: _cache[5] || (_cache[5] = $event => $data.successCountDown = 0),
    onCloseCountdown: $options.successCountDownChanged
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", {
      class: "mb-2",
      innerHTML: $data.message
    }, null, 8, _hoisted_4), _createElementVNode("p", {
      class: "mb-2",
      innerHTML: $data.htmlContent
    }, null, 8, _hoisted_5)])]),
    _: 1
  }, 8, ["modelValue", "onCloseCountdown"])) : _createCommentVNode("", true), $data.type === $data.types.DANGER && !_ctx.isHtmlMessage ? (_openBlock(), _createBlock(_component_b_alert, {
    key: 3,
    modelValue: $data.dangerCountDown,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.dangerCountDown = $event),
    dismissible: "",
    variant: "danger",
    onClosed: _cache[7] || (_cache[7] = $event => $data.dangerCountDown = 0),
    onCloseCountdown: $options.dangerCountDownChanged
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString($data.message), 1)]),
    _: 1
  }, 8, ["modelValue", "onCloseCountdown"])) : _createCommentVNode("", true), $data.type === $data.types.DANGER && _ctx.isHtmlMessage ? (_openBlock(), _createBlock(_component_b_alert, {
    key: 4,
    modelValue: $data.dangerCountDown,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.dangerCountDown = $event),
    dismissible: "",
    variant: "danger",
    onClosed: _cache[9] || (_cache[9] = $event => $data.dangerCountDown = 0),
    onCloseCountdown: $options.dangerCountDownChanged
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("p", {
      class: "mb-2",
      innerHTML: $data.message
    }, null, 8, _hoisted_7), _createElementVNode("p", {
      class: "mb-2",
      innerHTML: $data.htmlContent
    }, null, 8, _hoisted_8)])]),
    _: 1
  }, 8, ["modelValue", "onCloseCountdown"])) : _createCommentVNode("", true), $data.type === $data.types.WARNING ? (_openBlock(), _createBlock(_component_b_alert, {
    key: 5,
    modelValue: $data.warningCountDown,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.warningCountDown = $event),
    dismissible: "",
    variant: "warning",
    onClosed: _cache[11] || (_cache[11] = $event => $data.warningCountDown = 0),
    onCloseCountdown: $options.warningCountDownChanged
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString($data.message), 1)]),
    _: 1
  }, 8, ["modelValue", "onCloseCountdown"])) : _createCommentVNode("", true)], 512)), [[_vShow, $data.message !== '' && $data.visible]]);
}